/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 27/1/2023
 */

export const SortDirection = Object.freeze({
	ASC: "asc",
	DESC: "desc"
})
